import React from 'react'
import { Divider, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useSelector } from 'react-redux'
import { contentSlice } from '../../../reducers'

const useStyles = makeStyles(({ palette, spacing, typography, breakpoints }) => ({
  divider: {
    marginTop: spacing(1)
  },
  title: {
    ...typography.body.l,
    fontWeight: typography.weight.medium,
    color: palette.grey.shade[80]
  }
}))

export function DiscoverMoreContent (props) {
  const discoverMoreContent = useSelector(contentSlice.selectors.selectDiscoverMoreContent)
  const { title, renderArticle } = props
  const classes = useStyles()

  if (!discoverMoreContent?.length) {
    return null
  }

  return (
    <Grid container direction='column' spacing={2} data-test='discover-more-content'>
      <Grid item>
        <Typography component='h2' className={classes.title}>{title}</Typography>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item container direction='row' justifyContent='center' spacing={2} data-test='discover-more-content-list'>
        {(discoverMoreContent?.slice(0, 4) || Array.from(new Array(2))).map((item, idx) => (
          <Grid item sm={6} xs={12} key={item?.friendlyUrl ?? idx}>
            {renderArticle(item)}
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default DiscoverMoreContent
